import Table from "../table"
import { IconButton, Tooltip, Typography,DialogTitle,Dialog,TextField,Button,Box} from "@mui/material"
import ReceiptIcon from '@mui/icons-material/Receipt';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import Modal from '@mui/material/Modal';
import { useEffect, useState } from "react"
import CloseIcon from "@mui/icons-material/Close";
import { orderUpdateConfirmSlip,orderUpdateLogistics } from "../../services/orders"
import PhotoCameraBackIcon from '@mui/icons-material/PhotoCameraBack';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

let token = localStorage.getItem('accessToken')
let role_id = localStorage.getItem('role_id')
let user_id = localStorage.getItem('user_id')
const config = require('../../config')
const API_URL = config.API_URL
const HistoryTable = ({ rows }) => {
    const style_assign = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 300,
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 4,
    };
    const [open_slip, setOpenslip] = useState(false)
    const [open_sent, setOpenSent] = useState(false)

    
    const [img, setIMG] = useState(null)
    const [img_logis, setIMGLogis] = useState(null)

    const [order_id, setOrderId] = useState(null)
    const [confirm_payment, setConfirmPayment] = useState(null)
    const [selectedFile, setSelectedFile] = useState(null)
    const [img_upload, setIMGUpload] = useState('')
    const [open, setOpen] = useState(false)
    const [remark, setRemark] = useState('')
    const showSlip = (row) => {
        setOrderId(row.id)
        setIMG(row.img_slip)
        setConfirmPayment(row.confirm_payment)
        setOpenslip(true)
    }
    const showSent = (row) => {
        console.log(row)
        setOrderId(row.id)
        setIMGLogis(row.img_logis)
        setOpenSent(true)
    }
    
    const update = (url) => {

        orderUpdateLogistics({
            user_id: user_id,
            img_logis: url,
            order_id: order_id
        }, token)
            .then((res) => {
                window.location.reload();
                setOpenslip(true)
            }).catch(error => {
                console.log(error)
            })
    }
    const handleConfirmPayment = async () => {
        orderUpdateConfirmSlip({
            user_id: user_id,
            confirm_payment: 1,
            order_id: order_id
        }, token)
            .then((res) => {
                alert("ยืนยันสำเร็จ")
                window.location.reload();
                setOpenslip(true)
            }).catch(error => {
                console.log(error)
            })
    }
    const handleOpenDialog = (remark) => {
        setRemark(remark)
        setOpen(true)
    }
    const handleCloseDialog = () => {
        setOpen(false);
    };
    const columns = [
        { field: 'orders_no', headerName: 'เลขคำสั่งซื้อ', flex: 0.2, align: 'center' },
        { field: 'orderer', headerName: 'ผู้สั่ง', flex: 0.3, align: 'center' },
        { field: 'order_date', headerName: 'วันที่สั่ง', flex: 0.2, align: 'center' },
        { field: 'status', headerName: 'สถานะ', flex: 0.2, align: 'center' },
        {
            field: "remark",
            headerName: "หมายเหตุ",
            width: 120,
            align: 'center',
            renderCell: (params) => (
                <Tooltip title={<Typography>หมายเหตุ</Typography>} >
                    <IconButton color="primary" onClick={() => handleOpenDialog(params.row.remark)}>
                        <InfoOutlinedIcon sx={{ color: '#15322D', fontSize: 40 }} />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            field: "sent",
            headerName: "อัพโหลดรูป",
            flex: 0.2,
            align: 'center',
            renderCell: (params) => (
                <Tooltip title={<Typography>รูปการจัดส่ง</Typography>} >
                    <IconButton color="primary" onClick={() => showSent(params.row)}>
                        <PhotoCameraBackIcon sx={{ color: '#15322D', fontSize: 40 }} />
                    </IconButton>
                </Tooltip>
            ),
        },
        { field: 'product', headerName: 'สินค้า', flex: 0.3, align: 'center',
        renderCell: (params) => (
            <Tooltip title={params.value} arrow>
              <Typography noWrap>{params.value}</Typography>
            </Tooltip>
          )  },
        // { field: 'quantity', headerName: 'จำนวน', flex: 0.2, align: 'center' },
        { field: 'delivery_date', headerName: 'วันที่ส่งมอบ', flex: 0.2, align: 'center' },
        {
            field: "slip",
            headerName: "การรับเงิน",
            flex: 0.2,
            align: 'center',
            renderCell: (params) => (
                <Tooltip title={<Typography>การรับเงิน</Typography>} >
                    <IconButton color="primary" onClick={() => showSlip(params.row)}>
                        <ReceiptIcon sx={{ color: '#15322D', fontSize: 40 }} />
                    </IconButton>
                </Tooltip>
            ),
        },

    ]
    if (role_id !== '4') {
        columns.push({
            field: "detail",
            headerName: "การจ่ายเงิน",
            flex: 0.2,
            align: 'center',
            renderCell: (params) => (
                <Tooltip title={<Typography>การจ่ายเงิน</Typography>} >
                    <IconButton color="primary" onClick={() => { window.location.href = 'payment/' + params.row.id }}>
                        <LocalAtmIcon sx={{ color: '#15322D', fontSize: 40 }} />
                    </IconButton>
                </Tooltip>
            ),
        });
    }
    return (
        <>
            <Modal
                open={open_slip}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ zIndex: 2 }}
            >
                <Box sx={style_assign}>
                    <IconButton
                        style={{ position: "absolute", top: "0", right: "0" }}
                        onClick={() => setOpenslip(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                    <h3>หลักฐานการโอนเงิน</h3>
                    {img ? (
                        <img
                            src={img}
                            alt="หลักฐานการโอนเงิน"
                            style={{ width: "100%", height: "auto", marginTop: "20px" }}
                        />
                    ) : (
                        <p style={{ marginTop: "20px", color: "red" }}>ไม่มีหลักฐานการโอนเงิน</p>
                    )}
                    {confirm_payment == 1 ? (
                        <p style={{ marginTop: "20px", color: "green", fontWeight: "bold" }}>
                            ยืนยันการรับเงินแล้ว
                        </p>
                    ) : (
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ marginTop: "20px" }}
                            onClick={handleConfirmPayment}
                        >
                            ยืนยันการรับเงิน
                        </Button>
                    )}
                </Box>
            </Modal>
            <Modal
                open={open_sent}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ zIndex: 2 }}
            >
                <Box sx={style_assign}>
                    <IconButton
                        style={{ position: "absolute", top: "0", right: "0" }}
                        onClick={() => setOpenSent(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                    <h3>รูปการจัดส่งสินค้า</h3>
                    {img_logis ? (
                        <img
                            src={img_logis}
                            alt="รูปการส่ง"
                            style={{ width: "100%", height: "auto", marginTop: "20px" }}
                        />


                    ) : (
                        <> 
                        <input
                            type="file"
                            accept="image/*"
                            onChange={(event) => {
                                const file = event.target.files?.[0];
                                if (file) {
                                    setSelectedFile(file); // เก็บไฟล์ใน state
                                }
                            }}
                            style={{ marginTop: "20px" }} /><Button
                                variant="contained"
                                style={{
                                    marginTop: "20px",
                                    float: "right", // ปุ่มชิดขวา
                                }}
                                onClick={async () => {
                                    if (!selectedFile) {
                                        alert("กรุณาเลือกไฟล์ก่อน");
                                        return;
                                    }

                                    const formData = new FormData();
                                    formData.append("files", selectedFile);
                                    formData.append("type", 'logistics');
                                    formData.append("order_id", order_id);
                                    
                                    try {
                                        const response = await fetch(API_URL+"/upload", {
                                            method: "POST",
                                            headers: {'Authorization': `Bearer ${token}`},
                                            body: formData,
                                        });
                                        if (response.status) {
                                            console.log(response)
                                            alert("อัพโหลดไฟล์สำเร็จ");
                                            const result = await response.json();
                                            setIMGUpload(result.url);
                                            update(result.url)
                                        } else {
                                            alert("การอัพโหลดล้มเหลว");
                                        }
                                    } catch (error) {
                                        console.error("เกิดข้อผิดพลาด:", error);
                                        alert("เกิดข้อผิดพลาดในการอัพโหลดไฟล์");
                                    }
                                }}
                            >
                                อัพโหลดไฟล์
                            </Button>  </>
                    )}
                </Box>
            </Modal>
            <Table
                rows={rows}
                columns={columns}
            />
              <Dialog open={open} onClose={handleCloseDialog} fullWidth>
                <DialogTitle sx={{ justifyContent: 'center', display: 'flex', fontSize: '24px' }}>หมายเหตุ</DialogTitle>
                <TextField
                    sx={{ padding: 4 }}
                    variant="outlined"
                    value={remark}
                    InputProps={{
                        readOnly: true,
                    }}
                />
                <div style={{ paddingBottom: 3, justifyContent: 'center', display: 'flex' }}>
                    <Button
                        onClick={handleCloseDialog}
                        variant="contained"
                        sx={{
                            px: 4,
                            backgroundColor: '#C9D4C4',
                            color: '#15322D',
                            fontSize: '20px',
                            '&:hover': {
                                backgroundColor: '#A2B29F',
                            },
                        }}
                    >
                        ย้อนกลับ
                    </Button>
                </div>
            </Dialog>
        </>

    )
}

export default HistoryTable